import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getCompanybanks,
  companybanksListSuccessful,
  companybanksAddSuccessful,
  isModelVisible,
} from "./companybanksSlice";

// AUTH related methods
import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* getCompanybank({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/masters/companybanks/", params);
    yield put(companybanksListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* AddCompanybanks({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/companybanks/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Company Banks Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getCompanybanks({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Company Banks. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(companybanksAddSuccessful(null));
    } else {
      const response = yield call(
        postEdit,
        "/masters/companybanks/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Company Banks Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getCompanybanks({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Company Banks. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(companybanksAddSuccessful(null));
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

function* DeleteCompanybanks({ payload }) {
  var countryID = payload;
  try {
    const response = yield call(
      postDelete,
      "/masters/companybanks/" + countryID
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Company Banks has been deleted!
            </p>
          </div>
        ),
      }); put(getCompanybanks({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Company Banks has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchgetCompanybanks() {
  yield takeEvery("companybanks/getCompanybanks", getCompanybank);
}
export function* watchCompanybanksAdd() {
  yield takeEvery("companybanks/companybanksAdd", AddCompanybanks);
}

export function* watchCompanybanksDelete() {
  yield takeEvery("companybanks/companybanksDelete", DeleteCompanybanks);
}

function* CompanybanksSaga() {
  yield all([
    fork(watchgetCompanybanks),
    fork(watchCompanybanksAdd),
    fork(watchCompanybanksDelete),
  ]);
}

export default CompanybanksSaga;
